<template>
	<div>

		<!-- <v-dialog 
			v-model="disableDialog" 
			width="40%"
			elevation="8"
			persistent>
				<DisableProject 
					:disableArgs="disableArgs"
					@refreshModule="refreshModule"
					@closeDisableDialog="closeDisableDialog"
					@triggerUserFeedback="triggerUserFeedback" />
		</v-dialog>  -->

		<v-dialog 
			v-model="profileDialog" 
			transition="dialog-bottom-transition"
			max-width="83%"
			scrollable>
			<v-card>
				<v-card-title class="info pewter--text justify-end">
					<v-btn 
						icon 
						dark 
						class="ml-3"
						@click="profileDialog = false">
						<v-icon color="pewter">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<ModuleQuestionnaire 
						v-if="readyToLoad"
						:user_id="questionnaireUserId"
						:module_key="moduleKey"
						:module_id="moduleId"
						:project_id="projectId"
						:questionsOnly="questionnaireQuestionsOnly"
						:isOpen="profileDialog"
						:openQuestionnaire="openQuestionnaire"
					/>
				</v-card-text>
				<v-card-actions class="info"></v-card-actions>
			</v-card>
		</v-dialog>

		<!-- <v-dialog 
			v-model="deliverableDialog" 
			transition="dialog-bottom-transition"
			width="50%">
			<v-card>
				<v-card-text>
					<UploadDeliverables 
						:ModuleData="projectDeliverables"
						:moduleKey="moduleKey"
						:projectId="projectId"
						:userId="module_details.user_id"
						:isDeliverable="true"
						:revisionDocCount="3"
						@closeUploadDeliverables="closeUploadDeliverables"
						@pullProjectDelivs="pullProjectDelivs"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog 
			v-model="titleDialog" 
			transition="dialog-bottom-transition"
			width="50%">
			<v-card>
				<v-card-title class="primary darken-1 white--text">Add an internal title for this project.</v-card-title>
				<v-card-text>
					<v-text-field
						v-model="updateProject.internal_project_title"
						class="my-4 pa-2"
						label="Title"
						single-line
						:rules="updateProject.internal_project_title != null ? max100chars : []"
						counter>
					</v-text-field>
					<div class="d-flex d-block justify-end">
						<v-btn
							class=""
							color="primary"
							:disabled="updateProject.internal_project_title == undefined || updateProject.internal_project_title.length > 100"
							@click="updateProjectTitle(updateProject)">
							Save
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog> -->

		<v-dialog 
			v-model="videoDialog" 
			persistent
			width="55%"
			elevation="8">
			<v-card>
				<v-card-title class="headline primary darken-1 white--text d-flex justify-space-between">
					{{ videoTitle }}
					<v-btn
						icon
						@click="closeVideo()">
						<v-icon 
							class="white--text">
							mdi-close
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="py-6 align-center mx-auto">                    
					<div v-if="videoValid === null || videoValid === false">
						<v-progress-circular   
							v-if="videoValid === null"
							indeterminate
							color="primary"
							class="mx-auto my-12 py-12 d-block"
							size="100"
							width="5">
						</v-progress-circular>

						<div v-if="videoValid === false" class="d-block my-12 py-12 text-center sansation_title">
							We're sorry, this video is not available at this time.
						</div>
					</div>

					<VideoPlayer v-if="videoValid"
						:key="videoUrl"
						:video_id="videoUrl"
						:video_src="videoSrc"
						:video_type="videoType" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<div class="d-flex py-5 px-6 d-block header_bg_color justify-end">
			<v-btn 
				icon
				outlined
				color="white"
				elevation="1"
				@click="closeModule()">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</div>

		<div v-if="!readyToLoad" class="text-center py-12 my-12" style="width: 100%">
			<v-progress-circular
				indeterminate 
				color="error darken-3" 
				class="my-12 py-12" 
				size="100" 
				width="8">
			</v-progress-circular>
		</div>
		
		<div v-else>
			<div class="px-5 pt-5 d-flex d-block align-top justify-space-between">
				<div class="mb-5 align-top d-flex align-center">
					<customIcon v-if="module_details.module_key && module_details.module_key != ''" :name="module_details.module_key" class="d-inline ml-n2 mr-1 info--text text--lighten-2 icon-size-header" />
					<div class="d-inline info--text text--lighten-2 label_large">
						<div class="d-inline" v-html="module_details.module_name"></div>
						<!-- <v-icon
							small
							color="primary"
							class="d-inline ml-2"
							@click.stop.prevent="openProjectTitle(module_details)">
							mdi-pencil
						</v-icon> -->
					</div>
				</div>
					
				<!-- <div class="justify-space-between pt-2">
					<div class="d-block text-right">
						<v-btn
							v-if="module_details.steps_completed >= 1"
							small
							outlined
							color="primary"
							class="mr-3 justify-end"
							@click.stop.prevent="exportAnswers(module_details)">
							Export Answers
						</v-btn>
						<v-btn
							small
							elevation=0
							color="primary"
							class="justify-end"
							@click.stop.prevent="openQuestionnaire(module_details)">
							View Questionnaire
						</v-btn>
					</div>
				</div> -->
			</div>

			<v-card-text class="my-0 py-0">
				<v-card outlined class="mt-1 mb-2 py-1 px-5 d-flex align-center justify-space-between sansation menu_bg_primary">
					<div class="d-flex d-inline">
						<div v-for="(item, index) in menuItems" 
							:key="index"
							class="d-flex d-inline align-center">
								<v-divider vertical v-if="index > 0" class="mx-5"></v-divider>
								<a v-if="module_detail_view != item.value" @click="moduleView(item.value)"><div class="primary--text text--darken-1">{{ item.label }}</div></a>
								<div v-if="module_detail_view == item.value" class="grey--text">{{ item.label }}</div>
						</div>
					</div>
					<div class="d-flex d-inline justify-end align-center">
						<div class="d-inline caption grey--text">created: {{ formatThisDate(module_details.created_date) }}</div> 
						<v-divider vertical class="mx-3"></v-divider>
						<div class="d-inline caption grey--text">{{ module_details.module_id }}</div>
					</div>
				</v-card>

				<v-card v-if="module_detail_view == 'overview'" elevation="0" class="px-5 pb-12">
					<ModuleData
						:moduleDetails="module_details"
						@saveModuleData="saveModuleData" />
				</v-card>

				<v-card v-if="module_detail_view == 'roadmap'" elevation="0" class="mt-6 px-5 pb-12">
					<ModuleRoadmap
						:moduleID="module_details.module_id"
						@playResourceVideo="playResourceVideo"
						@triggerUserFeedback="triggerUserFeedback" />
				</v-card>

				<!-- <v-card v-if="module_detail_view == 'activity'" elevation="0" class="mt-6 px-5 pb-12">
					<ActivityLogs
						:projectID="module_details.project_id"
						:userID="module_details.user_id" />
				</v-card> -->

				<v-card v-if="module_detail_view == 'psr'" elevation="0" class="mt-6 px-5 pb-12">
					<PsrTemplate
						:moduleID="module_details.module_id"
						:changeButtonColor="changeButtonColor"
						:showWarningToSave="showWarningToSave"
						:refreshModuleTemplate="refreshModuleTemplate"
						@showWarningToSave="handleShowWarningToSave"
						@triggerUserFeedback="triggerUserFeedback"
					/>
				</v-card>

				<v-card v-if="module_detail_view == 'meetings'" elevation="0" class="mt-6 px-5 pb-12">
					<PsrMeetings
						:moduleID="module_details.module_id"
						:changeButtonColor="changeButtonColor"
						:showWarningToSave="showWarningToSave"
						@showWarningToSave="handleShowWarningToSave"
						@triggerUserFeedback="triggerUserFeedback"
					/>
				</v-card>

				<v-card v-if="module_detail_view == 'docs'" elevation="0" class="mt-6 px-5 pb-12">
					<ModuleResources
						:moduleDetails="module_details"
						@toggleVisiblity="toggleVisiblity"
						@playResourceVideo="playResourceVideo"
						@triggerUserFeedback="triggerUserFeedback" />
				</v-card>

				<v-card v-if="module_detail_view == 'team'" elevation="0" class="mt-6 px-5 pb-12">
					<ModuleTeam
						:moduleDetails="module_details"
						@triggerUserFeedback="triggerUserFeedback" />
				</v-card>

				<!-- <v-card v-if="module_detail_view == 'users'" elevation="0" class="mt-6 px-5 pb-12">
					<ProjectUsers
						:moduleDetails="module_details"
						@refreshUsers="refreshUsers" />
				</v-card>
				<v-card v-if="module_detail_view == 'resolutions' && ( module_details.modinfo.module_key && module_details.modinfo.module_key === 'entity-maintenance-program' )" elevation="0" class="mt-6 px-5 pb-12">
					<ProjectResolutions
						:moduleDetails="module_details"
					/>
				</v-card> -->

			</v-card-text>
			<v-card-actions class="pa-4 d-flex" style="border-top: 1px solid #BDBDBD">
				<!-- <v-btn 
					class="d-inline menu_bg_primary primary--text text--darken-1"
					elevation=0
					@click="initDisableProject(module_details)">
					<v-icon color="primary" class="mr-3" left>{{ module_details.is_archived ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon> {{ module_details.is_archived ? 'Unarchive this Project' : 'Hide this Project' }}
				</v-btn> -->
				<v-spacer></v-spacer>
				<v-btn 
					class="d-inline menu_bg_primary primary--text text--darken-1"
					elevation=0
					:loading="refreshing_module"
					@click="refreshModule(module_details)">
					<v-icon color="primary">mdi-refresh</v-icon>
				</v-btn>
			</v-card-actions>
		</div>
	</div>
</template>


<script>  
	import axios from "axios";
	import Cookie from 'js-cookie';
	import appUrls from '../helpers/environment';
    import { dataTimeDisplayFormatter } from './utilities'
	import { ExportToCsv } from 'export-to-csv';
	
	import ModuleData from './ModuleData';
	import PsrMeetings from './datamanagement/ProjectMeetings.vue';
	import PsrTemplate from './datamanagement/ProjectTemplates';
	import ModuleResources from './ModuleResources';
	import ModuleRoadmap from './ModuleRoadmap';
	import ModuleQuestionnaire from './ModuleQuestionnaire';
	import ModuleTeam from './ModuleTeam';
	import VideoPlayer from './video'

	export default {
		name: 'ModuleDetails',

		components: {
			  ModuleData,
			  ModuleQuestionnaire,
			  ModuleResources,
			  ModuleRoadmap,
			  ModuleTeam,
			  PsrMeetings,
			  PsrTemplate,
			  ModuleQuestionnaire,
			  VideoPlayer,
		},

		props: {
			module_id: String,
			closeDetailDialog: Function
		},

		computed: {
			questionnaireUserId () {
				if ( this.module_details && this.module_details.user_id ) return this.module_details.user_id
				if ( Array.isArray(this.user_data) && this.user_data.length && this.user_data[0] && this.user_data[0].user_id ) return this.user_data[0].user_id
				return ''
			},

			questionnaireQuestionsOnly () {
				return !this.projectId || !this.questionnaireUserId
			}
		},

		data () {
			return {
				trigger_copied: false,
				module_details: {},
				menuItems: [
					{
						value: 'overview',
						label: 'Overview'
					},
					{
						value: 'roadmap',
						label: 'Roadmap'
					},
					{
						value: 'docs',
						label: 'Resource Docs'
					},
					{
						value: 'psr',
						label: 'PSR Template'
					},
					{
						value: 'meetings',
						label: 'PSR Meetings'
					},
					{
						value: 'questionnaire',
						label: 'Questionnaire'
					},
					{
						value: 'team',
						label: 'Team'
					}
				],
				user_data: {},
				// date_menu: false,
				// disableDialog: false,
				profileDialog: false,
				// deliverableDialog: false,
				// titleDialog: false,
				videoDialog: null,
				videoUrl: '',
				videoSrc: '',
				videoType: '',
				videoTitle: 'Resource Video',
				videoValid: null,
				
				refresh_docs: false,
				refreshing_module: false,
				triggerFeedback: false,
				module_detail_view: 'overview',
				moduleKey: '',
				moduleId: '',
				projectId: '',
				show_this: '',
				projectDeliverables: [],
				max100chars: [v => v.length <= 100 || 'Max 100 characters'],
				updateProject: {},
				readyToLoad: false,
				archiveWork: false,
				showWarningToSave: false,
				showWarningDialog: false,
				changeButtonColor: false,
				refreshModuleTemplate: false,
			}
		},

		watch: {            
			module_id: {
				handler(val){
					if (val) {
						this.moduleDetails(this.module_id);
					}
				}
			}
		},

		mounted () {
			this.moduleDetails();
		},
		
		methods: {
			handleShowWarningToSave(value) {
				this.showWarningToSave = value;
				this.changeButtonColor = value;
			},

			closeModule: function () {
				if ( this.showWarningToSave ) {
					this.changeButtonColor = true
					this.showWarningDialog = true;
					this.triggerUserFeedback( true, "Please save your changes before closing this dialog." );
				} else {
					this.readyToLoad = false
					this.module_detail_view = 'overview'
					this.$emit('closeDetailDialog', false)
				}
			},
			
			moduleView: async function (view) {
				if ( this.showWarningToSave ) {
					this.triggerUserFeedback( true, "Please save your changes before changing the view." );
				} else if ( view === 'questionnaire' ) {
					this.openQuestionnaire(this.module_details)
				} else {
					this.module_detail_view = view
				}
			},

			openQuestionnaire: function ( mod ) {
				const moduleInfo = mod && mod.modinfo ? mod.modinfo : {}
				this.moduleKey = moduleInfo.module_key || mod.module_key || this.moduleKey || ''
				this.projectId = mod && mod.project_id ? mod.project_id : ''
				this.moduleId = mod && mod.module_id ? mod.module_id : this.module_id || ''

				setTimeout(() => {
					this.profileDialog = true
				}, 150)
			},

			triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
			    this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
			},

			formatThisDate: function ( date ) {
                if (!date) return '';
                
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }
                return dataTimeDisplayFormatter(date, options)
                // return dateFormat(date.substr(0,10)+' 00:00:00', mask)
            },

			moduleDetails: async function () {
				try {
					await this.getLists();
					const current_module = await axios.get(`${appUrls.api}/api/admin/module/${this.module_id}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})
					
					if ( current_module.data.outcome ) {
						this.module_details = current_module.data.module_data
						this.readyToLoad = true
					} else {
						this.$feedback.error( current_module.data.message );
					}
				} catch ( error ) {
					console.log(error);
				}
			},

			getLists: async function () {
				try {
					let optionsLists = [ 
						{'name': 'entity_filing_status', 'type': 'txt'},
						{'name': 'admin_document_status', 'type': 'txt'}
					];

					const get_lists = await axios.post(`${appUrls.api}/api/lists`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
						list_options: optionsLists
					})

					if ( get_lists.data.outcome ) {
						this.arrLists = get_lists.data.lists;                        
						// SET PROPERTIES WITH THIER APPROPRIATE LIST
						for (let l in this.arrLists) {
							if (this.arrLists[l].name == 'entity_filing_status') this.entity_filing_status_list = this.arrLists[l].list
							if (this.arrLists[l].name == 'admin_document_status') this.admin_document_status_list = this.arrLists[l].list
						}
					}
				} catch ( error ) {
					console.log(error);
				};
			},

			saveModuleData: async function ( module ) {
                try {
                    const module_data_rs = await axios.post(`${appUrls.api}/api/admin/save_module_data`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        module
                    })

                    if ( module_data_rs.data.outcome ) {
                        this.triggerUserFeedback( true, module_data_rs.data.message);
                    } else {
                        this.triggerUserFeedback( true, module_data_rs.data.message, 'accent' );
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

			refreshModule: async function ( mod ) {
				try {
					this.refreshModuleTemplate = true;
					this.refreshing_module = true;
					const mod_rs = await axios.get(`${appUrls.api}/api/admin/module/${mod.module_id}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
					})

					setTimeout(() => {
						mod = mod_rs.data.module_data                        
						this.refreshing_module = false;
					}, 1000)
					setTimeout(() => {
						this.triggerUserFeedback( true, "Module data has been refreshed");
					}, 2000)
				
				} catch ( error ) {
					console.log(error);
				}
			},

			toggleVisiblity: function () {
				// ModuleResources exposes this callback in several parent views.
				// Keep a local no-op handler so Vue render bindings stay valid.
			},

			playResourceVideo: async function ( data ) {
				this.videoUrl   = data.url
				// https://mycompass-production.s3.us-west-2.amazonaws.com/resource_files/Introduction%20Video.mp4?
				// X-Amz-Algorithm=AWS4-HMAC-SHA256&
				// X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&
				// X-Amz-Credential=AKIAXMOUSJ6P5QSDNUMA%2F20250723%2Fus-west-2%2Fs3%2Faws4_request&
				// X-Amz-Date=20250723T164445Z&
				// X-Amz-Expires=259200&
				// X-Amz-Signature=9939f9345861ac75ba6d5d847b9b8f75a0d14bf61ff5d9b03c05de4b9ff4e545&
				// X-Amz-SignedHeaders=host&
				// x-amz-checksum-mode=ENABLED&
				// x-id=GetObject
				this.videoValid = await this.videoValidation( this.videoUrl )

				if ( this.videoValid ) {
					this.videoDialog = true
					this.videoId     = data.fileid
					this.videoSrc    = data.url.includes('vimeo') ? 'Vimeo' : 'AWS'
					this.videoTitle  = data.title
					this.videoType   = data.type
				}
			},

			videoValidation: async function ( videoUrl ) {
				try {
					if ( videoUrl.includes('vimeo') ) return true

					const video_params = new URLSearchParams(videoUrl.split('?')[1]);
					const signature = video_params.get('X-Amz-Signature') || video_params.get('Signature') || false // S3 OR CLOUDFRONT SIGNED URL
					const expires = video_params.get('X-Amz-Expires') || video_params.get('Expires') || false
					const today = Date.now()

					return signature && expires && today >= expires
				} catch (error) {
					// console.log('error', error.response)
					return false
				}
			},

			closeVideo: async function () {
				// Reset all video variables
				this.videoDialog    = null
				this.videoValid     = null
				this.videoId        = ''
				this.videoSrc       = ''
				this.videoUrl       = ''
				this.videoType      = ''
				this.videoTitle     = 'Resource Video'
			},

			// handleCopyEmail: function () {
			// 	navigator.clipboard.writeText(document.querySelector('div#copy-email').innerText.trim())
			// 	this.trigger_copied = true;
			// 	setTimeout(() => { this.trigger_copied = false; }, 3000);
			// },

			// gatherInitialQuestionnaire: async function (parentProjId) {
			// 	const dataObj = {}
			// 	const res = await axios.get(`${appUrls.api}/api/user_data/${parentProjId}`, {
			// 		headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
			// 	})

			// 	for (const { section, question, value_type, answer, date_saved } of res.data.values) {
			// 		const key = `${section}_${question}`
			// 		// this.last_saved = new Date(date_saved).toLocaleString('en-US')

			// 		if (value_type === 'object' && answer != '') {
			// 		dataObj[key] = JSON.parse(answer)
			// 		} else {
			// 		dataObj[key] = answer
			// 		}
			// 	}
			// 	return dataObj
			// }
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.bg_pewter {
		background-color: #E9EAEC !important;
	}
	.menu_bg_primary {
		background-color: #eef7f8 !important;
	}
	.header_bg_color {
		font-size: 1.15em !important;
		background-color: var(--v-primary-darken1)
	}
	.header_text_small {
		font-size: .9em !important;
	}
	.header_text_big {
		font-size: 1.1em !important;
	}
	.icon-size {
		width: 3rem;
	}
	.icon-size-small {
		width: 2.25rem;
	}
	.icon-size-header {
		width: 3rem;
	}
	.icon-center {
		margin: 0 auto;
	}
	.refresh_response {
		font-size: .8rem;
	}
	.click_indicator {
	width: 50px; 
	height: 3px; 
	border-top: 1px dotted rgba(0,0,0,.3);
	border-bottom: 1px dotted rgba(0,0,0,.3);
	}
	.user_link {
		text-decoration: none;
	}
	.user_link:hover {
		text-decoration: underline;
	}
</style>


// WEBPACK FOOTER //
// src/components/ModuleDetails.vue